const overviewActionTypes = {
    SET_OVERVIEW_DATA: 'SET_OVERVIEW_DATA',
    CLEAR_OVERVIEW: 'CLEAR_OVERVIEW'
}

export default overviewActionTypes
